import {useData} from "vike-react/useData";
import {ApiProfileUserData, ApiShoutboxMessage} from "#/src/definitions/ApiDefinitions";
import {TimeDisplay} from "#/src/components/TimeDisplay";
import clock from "#/src/assets/svg/clock.svg";
import {Sort} from "#/src/utils/sort-utils";
import {usePageContext} from "vike-react/usePageContext";
import {getProfileUrl} from "#/src/utils/profile-url";
import {DataWrapped} from "#/src/definitions/AppDefinitions";
import {AvatarWithFallback} from "#/src/components/AvatarWithFallback";
import React from "react";

export function ShoutboxPeek() {
  const {data: profileData} = useData() as DataWrapped<ApiProfileUserData>;
  const {urlPathname} = usePageContext();
  function render() {
    return <div className="shoutbox-wrapper">
      <div className="title-between mb-6 mt-4">
        <h2 className="basic-headline basic-headline-sm">
          Dodane w ShoutBox
        </h2>
        {urlPathname.startsWith("/my-profile") && <a href={"/my-profile/shoutbox"} className="more-link">
          Pokaż więcej
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.5 15L12.5 10L7.5 5" stroke="#EEF5F8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </a>}
      </div>
      {renderMessages()}
    </div>
  }

  function renderMessages() {
    const sorted = Sort.byDate(profileData.user.messagesPeek);
    return sorted.map((shoutboxMessage: ApiShoutboxMessage) => {
      return <div key={shoutboxMessage.id} className="shoutbox-comment">
        <div className="shoutbox-body">
          <p>{shoutboxMessage.message}</p>
          <div className="article-author mt-1">
            <div className="author">
              <AvatarWithFallback user={shoutboxMessage.author} className={"avatar avatar-40"}/>
              <a href={getProfileUrl(shoutboxMessage.author)} className="author-link">{shoutboxMessage.author.username}</a>
            </div>
            <div className="article-date">
              <img src={clock} alt={"Data"} className={"me-2"}/>
              <span>
                <TimeDisplay date={shoutboxMessage.creationDate}/>
                {shoutboxMessage.pendingModeration && <span className={"ms-2 text-primary"}>W moderacji</span>}
              </span>
            </div>
          </div>
        </div>
      </div>
    });
  }

  return render();
}